import React from 'react';

export type Props = {};

const ColumnChart: React.FC<Props> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.125 20.25H19.875C19.5766 20.25 19.2905 20.1315 19.0795 19.9205C18.8685 19.7095 18.75 19.4234 18.75 19.125V4.875C18.75 4.57663 18.8685 4.29048 19.0795 4.0795C19.2905 3.86853 19.5766 3.75 19.875 3.75H22.125C22.4234 3.75 22.7095 3.86853 22.9205 4.0795C23.1315 4.29048 23.25 4.57663 23.25 4.875V19.125C23.25 19.4234 23.1315 19.7095 22.9205 19.9205C22.7095 20.1315 22.4234 20.25 22.125 20.25Z"
        fill="#62339C"
      />
      <path
        d="M16.125 20.25H13.875C13.5766 20.25 13.2905 20.1315 13.0795 19.9205C12.8685 19.7095 12.75 19.4234 12.75 19.125V8.625C12.75 8.32663 12.8685 8.04048 13.0795 7.8295C13.2905 7.61853 13.5766 7.5 13.875 7.5H16.125C16.4234 7.5 16.7095 7.61853 16.9205 7.8295C17.1315 8.04048 17.25 8.32663 17.25 8.625V19.125C17.25 19.4234 17.1315 19.7095 16.9205 19.9205C16.7095 20.1315 16.4234 20.25 16.125 20.25Z"
        fill="#62339C"
      />
      <path
        d="M10.125 20.25H7.875C7.57663 20.25 7.29048 20.1315 7.0795 19.9205C6.86853 19.7095 6.75 19.4234 6.75 19.125V11.625C6.75 11.3266 6.86853 11.0405 7.0795 10.8295C7.29048 10.6185 7.57663 10.5 7.875 10.5H10.125C10.4234 10.5 10.7095 10.6185 10.9205 10.8295C11.1315 11.0405 11.25 11.3266 11.25 11.625V19.125C11.25 19.4234 11.1315 19.7095 10.9205 19.9205C10.7095 20.1315 10.4234 20.25 10.125 20.25Z"
        fill="#62339C"
      />
      <path
        d="M4.125 20.25H1.875C1.57663 20.25 1.29048 20.1315 1.0795 19.9205C0.868526 19.7095 0.75 19.4234 0.75 19.125V14.625C0.75 14.3266 0.868526 14.0405 1.0795 13.8295C1.29048 13.6185 1.57663 13.5 1.875 13.5H4.125C4.42337 13.5 4.70952 13.6185 4.9205 13.8295C5.13147 14.0405 5.25 14.3266 5.25 14.625V19.125C5.25 19.4234 5.13147 19.7095 4.9205 19.9205C4.70952 20.1315 4.42337 20.25 4.125 20.25Z"
        fill="#62339C"
      />
    </svg>
  );
};

export default ColumnChart;
